import { Base } from "../../framework/base";

export interface INumberTitle {
    number: number;
    title: string;
}

export class NumberTitle implements INumberTitle {
    number: number;
    title: string;

    constructor();
    constructor(obj: INumberTitle);
    constructor(obj?: any) {
        this.number = obj && obj.number || 0;
        this.title = obj && obj.title || "";
    }

    static createNumberTitle(number: number, title: string): INumberTitle {
        const result = new NumberTitle();
        result.number = number;
        result.title = title;
        return result;
    }

    static getTitleByNumber(num: number, items: INumberTitle[]): string {
        if (Base.isNullOrUndefined(num) || !items || items.length < 1) return "";
        const item = items.find(i => Base.equalInt(i.number, num));
        return item ? item.title : "";
    }
}